const BASE = process.env.REACT_APP_HOST_BASE_URL;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
});

export const getAllByEntity = async (token, entityType, entityId) => {
  try {
    const res = await fetch(`${BASE}/v1/country-translation/${entityType}/${entityId}`, {
      headers: headers(token),
    });
    if (res.ok) return await res.json();
  } catch (err) {
    console.error("getAllByEntity error:", err);
  }
  return [];
};

export const saveTranslationsBatch = async (token, dtos) => {
  const res = await fetch(`${BASE}/v1/country-translation/batch`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify(dtos),
  });
  if (!res.ok) throw new Error(`Translation save failed: ${res.status}`);
  return await res.json();
};

export const deleteTranslation = async (token, id) => {
  const res = await fetch(`${BASE}/v1/country-translation/${id}`, {
    method: "DELETE",
    headers: headers(token),
  });
  if (!res.ok) throw new Error(`Translation delete failed: ${res.status}`);
};

export const uploadTranslationsExcel = async (token, entityType, entityId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("entityType", entityType);
  if (entityId) formData.append("entityId", entityId);
  const res = await fetch(`${BASE}/v1/product/translation/upload`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  if (!res.ok) throw new Error(`Translation upload failed: ${res.status}`);
  return await res.json();
};

export const downloadTranslationExcelExample = async (token) => {
  const res = await fetch(`${BASE}/v1/product/translation/excel/example`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Template download failed: ${res.status}`);
  return res.blob();
};
